import { Dispatch, SetStateAction } from "react";

export function stateListeners(this: any, eventName: string, localState: any) {
  return {
    subscribe: <T = any>(callback: Dispatch<SetStateAction<T>>) => {
      const messageListener = (event: MessageEvent) => {
        console.log(
          `Received state change for ${eventName}:`,
          stateHasChanged(localState, event.data?.state),
          event.data
        );
        if (
          event.data &&
          event.data.type === "internalStateChange" &&
          event.data.name === eventName
        ) {
          console.log(
            `Updating local state for ${eventName}:`,
            event.data.state
          );
          callback(event.data.state);
        }
      };
      window.addEventListener("message", messageListener);
      return () => {
        window.removeEventListener("message", messageListener);
      };
    },
    sendStateChange: (state: any) => {
      console.log(`Sending state change for ${eventName}:`, state);
      window.postMessage({
        type: "internalStateChange",
        name: eventName,
        state,
      });

      return state;
    },
  };
}

export function stateHasChanged(currentState: any, newState: any): boolean {
  if (typeof currentState !== typeof newState) {
    return true;
  }

  if (typeof currentState === "object" && currentState !== null) {
    if (Array.isArray(currentState) && Array.isArray(newState)) {
      return (
        currentState.length !== newState.length ||
        currentState.some((item, index) => item !== newState[index])
      );
    } else {
      const currentKeys = Object.keys(currentState);
      const newKeys = Object.keys(newState);
      if (currentKeys.length !== newKeys.length) {
        return true;
      }
      return currentKeys.some((key) => currentState[key] !== newState[key]);
    }
  }

  return currentState !== newState;
}
